module.exports = __webpack_public_path__ + "img/P150T_weapon_48.9d196fc5.png";